import { Link } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { fetchCurrentUser } from '@/lib/auth';
import { cn } from '@/lib/utils';

// Abas do módulo Agentes. Conversas (chat, transversal) + pilares de gestão
// (admin-only). Some quando o usuário só tem acesso a Conversas — o chat fica
// como estava. À medida que Visão geral/Qualidade/Custo forem implementados,
// entram aqui.
type ModuleTab = 'visao-geral' | 'conversas' | 'qualidade' | 'autoaprendizado' | 'custo';

export function AgentesModuleTabs({ active, className }: { active: ModuleTab; className?: string }) {
  const { data: user } = useQuery({
    queryKey: ['auth', 'me'],
    queryFn: ({ signal }) => fetchCurrentUser(signal),
    staleTime: 5 * 60_000,
  });
  const isAdmin = user?.role === 'admin';

  const tabs: Array<{ id: ModuleTab; label: string; to: string }> = [];
  if (isAdmin) tabs.push({ id: 'visao-geral', label: 'Visão geral', to: '/agentes/visao-geral' });
  tabs.push({ id: 'conversas', label: 'Conversas', to: '/agentes' });
  if (isAdmin) {
    tabs.push({ id: 'qualidade', label: 'Qualidade & evals', to: '/agentes/qualidade' });
    tabs.push({ id: 'autoaprendizado', label: 'Autoaprendizado', to: '/agentes/autoaprendizado' });
    tabs.push({ id: 'custo', label: 'Custo & uso', to: '/agentes/custo' });
  }

  if (tabs.length < 2) return null;

  return (
    <div className={cn('flex gap-6 border-b border-border', className)}>
      {tabs.map((t) => (
        <Link
          key={t.id}
          to={t.to}
          className={cn(
            'relative py-2.5 text-[13.5px] transition-colors',
            active === t.id ? 'font-semibold text-text' : 'font-medium text-text-muted hover:text-text-2',
          )}
        >
          {t.label}
          {active === t.id && <span className="absolute inset-x-0 -bottom-px h-0.5 rounded-full bg-[var(--accent)]" />}
        </Link>
      ))}
    </div>
  );
}
